{
  "info": "Informação",
  "negative": "Erro",
  "positive": "Sucesso"
}
